import { c as _c } from "react/compiler-runtime";
import { ALLOWED_MEDIA, ResponsiveImage } from '@/app/components/media/app-image';
import { SPARTAN_HOME_EVENT_NAME } from '@/app/lcv/components/sections/spartan/home/shared/tracking';
import type { SpartanHomeSpecialOfferCardProps } from '@/app/lcv/components/sections/spartan/home/special-offer/offer-card/types';
import { SPARTAN_HOME_SPECIAL_OFFER_DATA_GA, SPARTAN_HOME_SPECIAL_OFFER_TRACKING } from '@/app/lcv/components/sections/spartan/home/special-offer/tracking';
import { getSpartanParallaxScrollProps } from '@/app/lcv/components/sections/spartan/products/shared/parallax-scroll';
import { getMediaOverlayBannerContentFadeClassName, MEDIA_OVERLAY_BANNER_CLASS_NAME, MEDIA_OVERLAY_BANNER_CONTENT_CLASS_NAME, MEDIA_OVERLAY_BANNER_CONTENT_LAYOUT_CLASS_NAME, MediaOverlayBannerContent } from '@/app/lcv/components/sections/spartan/shared/media-overlay/banner-content';
import { MediaOverlaySection } from '@/app/lcv/components/sections/spartan/shared/media-overlay/section';
import { cn } from '@/app/utils/cn';
export const SpartanHomeSpecialOfferCard = t0 => {
  const $ = _c(44);
  const {
    item,
    index,
    isActive: t1
  } = t0;
  const isActive = t1 === undefined ? true : t1;
  const {
    image,
    imageDesktop,
    containerClassName
  } = item;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["aspect-3-4", "md:aspect-16-9", "lg:aspect-8-3"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== containerClassName) {
    t3 = cn(MEDIA_OVERLAY_BANNER_CONTENT_CLASS_NAME, containerClassName);
    $[1] = containerClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getSpartanParallaxScrollProps({
      scrollSpeed: "0.07",
      enableTouchSpeed: true
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== image.src) {
    t5 = {
      src: image.src,
      media: `${ALLOWED_MEDIA.mdDown}`,
      sizes: "100vw"
    };
    $[4] = image.src;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== imageDesktop.src) {
    t6 = {
      src: imageDesktop.src,
      media: ALLOWED_MEDIA.mdUp,
      sizes: "(min-width: 1280px) 1176px, (min-width: 768px) 100vw"
    };
    $[6] = imageDesktop.src;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = image.alt;
  let t8;
  if ($[8] !== index) {
    t8 = SPARTAN_HOME_SPECIAL_OFFER_TRACKING.itemImage(index);
    $[8] = index;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== image.alt || $[11] !== t5 || $[12] !== t6 || $[13] !== t8) {
    t9 = <div className="absolute inset-0 translate-z-0 backface-hidden motion-safe:will-change-transform" {...t4}><ResponsiveImage fill={true} mobileSrc={t5} desktopSrc={t6} alt={t7} className="aspect-9-16 md:aspect-5-4 absolute inset-x-0 top-1/2 w-full -translate-y-1/2" testId={t8} /></div>;
    $[10] = image.alt;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isActive) {
    t10 = cn("size-full", MEDIA_OVERLAY_BANNER_CONTENT_LAYOUT_CLASS_NAME, getMediaOverlayBannerContentFadeClassName(isActive));
    $[15] = isActive;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== index) {
    t11 = SPARTAN_HOME_SPECIAL_OFFER_TRACKING.itemHeader(index);
    $[17] = index;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== index) {
    t12 = SPARTAN_HOME_SPECIAL_OFFER_TRACKING.itemLogo(index);
    $[19] = index;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== index) {
    t13 = SPARTAN_HOME_SPECIAL_OFFER_TRACKING.itemLogoDesktop(index);
    $[21] = index;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== index) {
    t14 = SPARTAN_HOME_SPECIAL_OFFER_TRACKING.itemCta(index);
    $[23] = index;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== index) {
    t15 = () => SPARTAN_HOME_SPECIAL_OFFER_TRACKING.itemButton(index);
    $[25] = index;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
    t16 = {
      header: t11,
      logo: t12,
      logoDesktop: t13,
      buttonGroup: t14,
      button: t15
    };
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      eventName: SPARTAN_HOME_EVENT_NAME,
      group: SPARTAN_HOME_SPECIAL_OFFER_DATA_GA.section
    };
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== item || $[35] !== t16) {
    t18 = <MediaOverlayBannerContent item={item} testIds={t16} tracking={t17} />;
    $[34] = item;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t10 || $[38] !== t18) {
    t19 = <div className={t10}>{t18}</div>;
    $[37] = t10;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t19 || $[41] !== t3 || $[42] !== t9) {
    t20 = <MediaOverlaySection aspectRatio={t2} className={MEDIA_OVERLAY_BANNER_CLASS_NAME} contentClassName={t3} media={t9}>{t19}</MediaOverlaySection>;
    $[40] = t19;
    $[41] = t3;
    $[42] = t9;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
};